document.addEventListener('DOMContentLoaded', function () {
  var targetTitles = [
    'Shop By Color',
    'Most Wanted Lens Collection',
    'Instagram and TikTok Top Trending Color Contacts',
    'Customer Review',
    'Frequently Ask Question'
  ];

  var arrowSVG = '<svg class="toggle-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  document.querySelectorAll('.hero__title').forEach(function (heading) {
    var text = heading.textContent.trim();
    if (targetTitles.indexOf(text) === -1) return;

    var content = heading.parentElement.querySelector('.hero__text.rte');
    if (!content) return;

    heading.classList.add('js-toggle-heading');
    content.classList.add('js-toggle-content');
    heading.insertAdjacentHTML('beforeend', arrowSVG);

    heading.addEventListener('click', function () {
      heading.classList.toggle('is-open');
      content.classList.toggle('is-open');
    });
  });
});